import { Box, ColorOptions, convertHexToRGBA, Icon, ModalDialogNew, Spacer, Text, TextInput } from '@jfs/ui-new'
import { isEmpty } from '@jfs/utils'
import { useState } from 'react'
import { Dimensions, useWindowDimensions } from 'react-native'
import { TableComponent } from '../../comps/TableComponent'
import { placeholdertextMap, searchFiltersData } from '../../data/static/data'
import { useStores } from '../../data/store'
import { Colors, logEvent } from '../../util/util'

export const SearchBarNew = ({ onClosePress = () => null, onSearchPress }) => {
  const { width } = useWindowDimensions()
  const { searchFilterItem, setSearchFilterItem, searchString, setSearchString } = useStores((store) => ({
    searchFilterItem: store.settings.metaData.getSearchFilterItem(),
    setSearchFilterItem: store.settings.metaData.setSearchFilterItem,
    searchString: store.settings.metaData.getSearchString(),
    setSearchString: store.settings.metaData.setSearchString,
  }))

  const [showDropdown, setDropDownShow] = useState(false)
  const [previousFilterItem, setPreviousFilterItem] = useState('')

  const closeButton = () => {
    return (
      <Box
        w={32}
        h={32}
        justify={'center'}
        align={'center'}
        underlayColor="LIGHTEST_GREY"
        testID="close"
        onPress={() => [onClosePress(), setSearchString('')]}>
        <Icon id="CLEAR" color={convertHexToRGBA(Colors.BLACK, 65) as ColorOptions} size={20} />
      </Box>
    )
  }

  const updateText = (textEntered: string) => {
    setSearchString(textEntered)
  }

  const handleClosePress = () => {
    setDropDownShow(!showDropdown)
    onClosePress()
  }

  const renderListItem = ({ item }: any) => {
    const handlePress = () => {
      logEvent('item_press', 'searchby_filter')
      setSearchFilterItem(item?.value)
      setDropDownShow(false)
    }
    return (
      <Box
        justifyContent={'center'}
        pv={16}
        ph={24}
        testID="search-item"
        onPress={handlePress}
        underlayColor={'TRANSPARENT'}>
        <Text
          fontFamily={'JioType-Medium'}
          fontSize={14}
          numberOfLines={1}
          color={Colors.BLACK_14 as ColorOptions}
          lineHeight={20}
          letterSpacing={-0.07}>
          {item?.name ?? ''}
        </Text>
      </Box>
    )
  }
  const keyExtractor = (item: any): string => {
    return item?.id
  }

  const SearchSelectionComp = (handleClose: any) => (
    <Box bg="WHITE" safeArea borderTopLeftRadius={24} borderTopRightRadius={24} pv={32}>
      <Box
        paddingHorizontal={24}
        flexDirection={'row'}
        testID="close-search"
        onPress={handleClose}
        justifyContent={'space-between'}
        alignItems={'center'}
        underlayColor={'TRANSPARENT'}
        height={32}>
        <Text
          textAlign="center"
          fontSize={24}
          fontFamily={'JioType-Black'}
          title={'Search By'}
          color={Colors.BLACK_14 as ColorOptions}
        />
        <Icon size={24} id="CLOSE" color="BLACK" />
      </Box>
      <Spacer direction="vertical" size={24} />
      <Box overflowY={'scroll'} maxHeight={Dimensions.get('screen').height * 0.6}>
        <TableComponent
          value={''} //Routes value
          canFetchMore={false}
          ListContent={searchFiltersData}
          hide={false}
          isCustom={true}
          RenderCustomElement={renderListItem}
          keyExtractor={keyExtractor}
        />
      </Box>
    </Box>
  )

  const rightComp = () => {
    if (isEmpty(searchString)) {
      return null
    }
    return closeButton()
    // if (
    //   !(state === 'pending' || (showSearchResult && searchString === text)) ||
    //   previousFilterItem !== searchFilterItem
    // ) {
    //   return searchButton(onSearchIconPress, text)
    // } else {
    //   return closeButton()
    // }
  }
  return (
    <Box bg={'WHITE'} pl={24}>
      <Box
        flexDirection="row"
        width={'100%'}
        borderWidth={1}
        h={48}
        align={'center'}
        borderRadius={8}
        pl={8}
        pr={6}
        borderColor={'PRIMARY' as ColorOptions}>
        <Box
          p={8}
          underlayColor={'TRANSPARENT'}
          flexDirection={'row'}
          onPress={() => [logEvent('btn_press', 'open_searchby_filters'), setDropDownShow(!showDropdown)]}
          bg={convertHexToRGBA(Colors.PRIMARY, 16) as ColorOptions}
          alignItems={'center'}
          h={32}
          borderRadius={4}>
          <Text
            value={searchFilterItem}
            color={Colors.BLACK_14 as ColorOptions}
            fontSize={12}
            fontFamily={'JioType-Medium'}
            lineHeight={18}
            letterSpacing={-0.06}
          />
          <Icon id={!showDropdown ? 'ARROW_DOWN' : 'ARROW_UP'} color={Colors.BLACK_14 as ColorOptions} size={16} />
        </Box>
        <Box f={1} pl={12}>
          <TextInput
            value={searchString}
            fontSize={16}
            placeholder={placeholdertextMap[searchFilterItem]}
            onFocusBottomLineColor="TRANSPARENT"
            autoCorrect={false}
            placeholderTextColor={convertHexToRGBA(Colors.BLACK, 65) as ColorOptions}
            fontFamily={'JioType-Medium'}
            fontWeight={'500'}
            lineHeight={24}
            autoFocus={true}
            selectionColor={'PRIMARY'}
            onChangeText={(textEntered: string) => {
              updateText(textEntered)
            }}
            rightComponent={rightComp()}
            onKeyPress={onSearchPress}
            keyboardType={
              searchFilterItem === 'Mobile Number' || searchFilterItem === 'Card No' ? 'number-pad' : undefined
            }
          />
        </Box>
      </Box>
      <ModalDialogNew animate={true} show={showDropdown} type="bottom" backgroundColor="TRANSPARENT">
        <Box bg={'WHITE'} borderTopLeftRadius={24} borderTopRightRadius={24}>
          {SearchSelectionComp(handleClosePress)}
        </Box>
      </ModalDialogNew>
    </Box>
  )
}
